import { render, staticRenderFns } from "./newMessageCard.vue?vue&type=template&id=6ffacd62&scoped=true"
import script from "./newMessageCard.vue?vue&type=script&lang=js"
export * from "./newMessageCard.vue?vue&type=script&lang=js"
import style0 from "./newMessageCard.vue?vue&type=style&index=0&id=6ffacd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffacd62",
  null
  
)

export default component.exports